import React from "react";

export default function Loading() {
  return (
    <>
      <div className="w-full flex justify-center items-center absolute">
        <svg
          width="25"
          viewBox="0 0 44 44"
          xmlns="http://www.w3.org/2000/svg"
          stroke="rgb(255, 255, 255)"
          class="w-8 h-8"
        >
          <g fill="none" fillRule="evenodd" strokeWidth="4">
            <circle cx="22" cy="22" r="1">
              <animate
                attributeName="r"
                begin="0s"
                dur="1.8s"
                values="1; 20"
                calcMode="spline"
                keyTimes="0; 1"
                keySplines="0.165, 0.84, 0.44, 1"
                repeatCount="indefinite"
              ></animate>
              <animate
                attributeName="stroke-opacity"
                begin="0s"
                dur="1.8s"
                values="1; 0"
                calcMode="spline"
                keyTimes="0; 1"
                keySplines="0.3, 0.61, 0.355, 1"
                repeatCount="indefinite"
              ></animate>
            </circle>
            <circle cx="22" cy="22" r="1">
              <animate
                attributeName="r"
                begin="-0.9s"
                dur="1.8s"
                values="1; 20"
                calcMode="spline"
                keyTimes="0; 1"
                keySplines="0.165, 0.84, 0.44, 1"
                repeatCount="indefinite"
              ></animate>
              <animate
                attributeName="stroke-opacity"
                begin="-0.9s"
                dur="1.8s"
                values="1; 0"
                calcMode="spline"
                keyTimes="0; 1"
                keySplines="0.3, 0.61, 0.355, 1"
                repeatCount="indefinite"
              ></animate>
            </circle>
          </g>
        </svg>
      </div>
    </>
  );
}
